import { getAdminAccessApi } from '@/core/api/generatedApiClient';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';
import type { AdminAccessResponse } from '@/core/generated/api';
import { isAxiosError } from 'axios';

/** Получает возможности сотрудника для всего административного интерфейса */
export const adminAccessService = {
    /** Загружает актуальные разделы, просмотры и действия */
    async getCurrent(): Promise<AdminAccessResponse> {
        try {
            const response = await getAdminAccessApi().getCurrentAdminAccess();

            return response.data;
        } catch (error: unknown) {
            if (isAxiosError(error) && error.response?.status === 403) {
                return {
                    isStaff: false,
                    hasFullAccess: false,
                    permissions: []
                };
            }

            return rethrowHandledApiError(error);
        }
    },
};
